import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import { InfoTextTooltip } from '../../attendee/detail/components/infotext-tooltip/infoTextTooltip';

export const DateInTable = ({ date, timezone, language }) => {
    const dateObject = new Date(date);
    const tzDate = moment(dateObject).tz(timezone || moment.tz.guess());

    const formatter_date = new Intl.DateTimeFormat(language, { dateStyle: 'short' });
    const formatted_date = formatter_date.format(tzDate);
    const formatter_time = new Intl.DateTimeFormat(language, { timeStyle: 'short' });
    const formatted_time = formatter_time.format(tzDate);

    return <InfoTextTooltip title={formatted_date} subtitle={formatted_time} tooltip={false} />;
};

DateInTable.defaultProps = {
    timezone: moment.tz.guess()
};

DateInTable.propTypes = {
    timezone: PropTypes.string,
    date: PropTypes.string,
    language: PropTypes.string
};
